import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { getOpenPopups } from 'reactApp/modules/popup/popup.selectors';
import { store } from 'reactApp/store';

export const isIosDevice = () => {
    if (typeof window === 'undefined') {
        return false;
    }
    return (
        /iP(ad|hone|od)/.test(window?.navigator?.platform) ||
        (window?.navigator?.platform === 'MacIntel' && window?.navigator?.maxTouchPoints > 1)
    );
};

function findScrollLockIgnoreParent(el) {
    let targetEl = el;
    while (targetEl && targetEl !== document.body) {
        if (typeof targetEl.getAttribute === 'function' && targetEl.getAttribute('body-scroll-lock-ignore')) {
            return true;
        }
        targetEl = targetEl.parentNode;
    }
}

// https://bugs.webkit.org/show_bug.cgi?id=153852#c43
// ios игнорирует overflow на body
export const lockScrollOnIos = () => {
    if (!isIosDevice()) {
        return;
    }

    const offsetY = window.pageYOffset;

    document.body.classList.add('body_fixed');

    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.top = `${-offsetY}px`;
    // fix для ios 15
    document.documentElement.style.minHeight = '100vh';
};

export const unlockScrollOnIos = () => {
    if (!isIosDevice()) {
        return;
    }

    const popups = getOpenPopups(store.getState());

    /**
     * На таче есть шторки, которые открываеются из другой шторки. При этом
     * при закрытии, родительская шторка остается открытой. В таком случае, нам не нужно
     * вызывать scrollUnlock. Для этого и проверяем - есть ли открытые попапы (шторки).
     */
    if (!popups.length) {
        const top = String(document.body.style.top || 0);
        const offsetY = Math.abs(parseInt(top));

        document.body.classList.remove('body_fixed');

        document.body.style.removeProperty('overflow');
        document.body.style.removeProperty('position');
        document.body.style.removeProperty('width');
        document.body.style.removeProperty('top');
        document.documentElement.style.removeProperty('minHeight');

        window.scrollTo(0, offsetY || 0);
    }
};

export function scrollLock(
    bodyScrollLockEl: HTMLElement | null | undefined,
    { allowTouchMove = false, reserveScrollBarGap = true }: { allowTouchMove?: boolean; reserveScrollBarGap?: boolean } = {}
) {
    if (!bodyScrollLockEl) {
        return;
    }

    disableBodyScroll(bodyScrollLockEl, {
        allowTouchMove: allowTouchMove ? findScrollLockIgnoreParent : null,
        reserveScrollBarGap,
    });

    lockScrollOnIos();
}

export function scrollUnlock(bodyScrollLockEl) {
    if (!bodyScrollLockEl) {
        return;
    }

    enableBodyScroll(bodyScrollLockEl);
    unlockScrollOnIos();
}
